import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=2df412c2"
import script from "./Debt.vue?vue&type=script&lang=js"
export * from "./Debt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports